// Piezas visuales compartidas del Dashboard IA (blanco, como el resto de LisualPro)
import React from 'react';

export const T = {
  bg: '#f9fafb',
  card: '#ffffff',
  card2: '#f3f4f6',
  line: '#e5e7eb',
  text: '#1f2937',
  muted: '#6b7280',
  green: '#10b981',
  blue: '#2563eb',
  yellow: '#ca8a04',
  red: '#ef4444',
};

export function Card({ title, right, children, style, bodyStyle }) {
  return (
    <section style={{ background: T.card, border: `1px solid ${T.line}`, borderRadius: 20, overflow: 'hidden', minWidth: 0, boxShadow: '0 1px 3px rgba(0,0,0,.06)', ...style }}>
      {(title || right) && (
        <header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap', padding: '12px 16px', borderBottom: `1px solid ${T.line}` }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', fontWeight: 600, fontSize: 15 }}>{title}</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>{right}</div>
        </header>
      )}
      <div style={{ padding: 16, ...bodyStyle }}>{children}</div>
    </section>
  );
}

export function Chip({ color = T.blue, on = true, children, onClick, title, small }) {
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        padding: small ? '2px 8px' : '4px 10px', borderRadius: 999,
        fontSize: small ? 11 : 12, fontWeight: 600, lineHeight: 1.4,
        border: `1px solid ${on ? color : T.line}`,
        background: on ? color + '1a' : '#fff',
        color: on ? color : T.muted,
        cursor: onClick ? 'pointer' : 'default', whiteSpace: 'nowrap',
      }}
    >
      {children}
    </button>
  );
}

export function Btn({ children, onClick, active, disabled, title, style }) {
  return (
    <button
      type="button"
      title={title}
      disabled={disabled}
      onClick={onClick}
      style={{
        padding: '6px 12px', borderRadius: 10, fontSize: 13, fontWeight: 600,
        border: `1px solid ${active ? T.blue : T.line}`,
        background: active ? T.blue : '#fff',
        color: disabled ? '#c4c9d1' : active ? '#fff' : T.text,
        cursor: disabled ? 'not-allowed' : 'pointer', whiteSpace: 'nowrap', ...style,
      }}
    >
      {children}
    </button>
  );
}

export function Seg({ options, value, onChange }) {
  return (
    <div style={{ display: 'inline-flex', gap: 4, padding: 3, borderRadius: 12, background: T.bg, border: `1px solid ${T.line}`, flexWrap: 'wrap' }}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          disabled={o.disabled}
          onClick={() => onChange(o.value)}
          style={{
            padding: '4px 10px', borderRadius: 9, fontSize: 12, fontWeight: 600, border: 'none',
            background: value === o.value ? T.blue : 'transparent',
            color: o.disabled ? '#c4c9d1' : value === o.value ? '#fff' : T.muted,
            cursor: o.disabled ? 'not-allowed' : 'pointer',
          }}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

export const inputStyle = {
  background: '#fff', color: T.text, border: `1px solid ${T.line}`, borderRadius: 8, padding: '5px 8px', fontSize: 13, colorScheme: 'light',
};
